// Faz BN (2026-05-10) — Design tokens
// UI/UX brief §10 + §11. Tüm renk/tipografi/spacing değerleri buradan akar;
// sayfa veya component dosyalarında literal hex / px değer kullanılmaz.

export const sidebarTokens = {
  bg:        "#0F2A4F",
  fg:        "#C9D5E8",
  fgActive:  "#FFFFFF",
  bgActive:  "rgba(255,255,255,0.08)",
  bgHover:   "rgba(255,255,255,0.04)",
  border:    "rgba(255,255,255,0.06)",
  sectionFg: "rgba(201,213,232,0.55)",
};

export const lightTokens = {
  // Brand
  primary:        "#1E4FA0",
  primaryHover:   "#1A4690",
  primarySoft:    "#E5EDF8",
  primaryFg:      "#FFFFFF",

  // Surface
  bg:             "#F7F8FA",
  surface:        "#FFFFFF",
  bgHover:        "#F1F3F6",
  bgElev:         "#FFFFFF",

  // Border
  border:         "#E5E7EB",
  borderStrong:   "#D1D5DB",

  // Text
  text:           "#111827",
  textSecondary: "#4B5563",
  textMuted:      "#9CA3AF",
  textDisabled:   "#C7CCD3",

  // Semantic
  success:        "#16A34A",
  successSoft:    "#DCFCE7",
  warning:        "#D97706",
  warningSoft:    "#FEF3C7",
  danger:         "#DC2626",
  dangerSoft:     "#FEE2E2",
  info:           "#0284C7",
  infoSoft:       "#E0F2FE",
};

export const darkTokens = {
  primary:        "#4D7BD0",
  primaryHover:   "#5C88D8",
  primarySoft:    "rgba(77,123,208,0.16)",
  primaryFg:      "#FFFFFF",

  bg:             "#0B0F1A",
  surface:        "#131927",
  bgHover:        "#1A2233",
  bgElev:         "#1A2233",

  border:         "#232B3D",
  borderStrong:   "#2E3850",

  text:           "#E5E7EB",
  textSecondary: "#9CA3AF",
  textMuted:      "#6B7280",
  textDisabled:   "#4B5563",

  success:        "#22C55E",
  successSoft:    "rgba(34,197,94,0.15)",
  warning:        "#F59E0B",
  warningSoft:    "rgba(245,158,11,0.15)",
  danger:         "#EF4444",
  dangerSoft:     "rgba(239,68,68,0.15)",
  info:           "#38BDF8",
  infoSoft:       "rgba(56,189,248,0.15)",
};

export const chartPalette = [
  "#1E4FA0",
  "#16A34A",
  "#D97706",
  "#7C3AED",
  "#DB2777",
  "#0E7490",
];

// Tipografi (UI/UX brief §11)
export const typography = {
  fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  fontFamilyMono: 'ui-monospace, "JetBrains Mono", Consolas, monospace',

  // [size, lineHeight, weight]
  display: { size: 32, line: 40, weight: 700 },
  h1:      { size: 24, line: 32, weight: 600 },
  h2:      { size: 20, line: 28, weight: 600 },
  h3:      { size: 16, line: 24, weight: 600 },
  body:    { size: 14, line: 22, weight: 400 },
  small:   { size: 12, line: 18, weight: 400 },
  label:   { size: 11, line: 16, weight: 600 },
};

// Spacing (4px baz)
export const spacing = {
  xs:  4,
  sm:  8,
  md: 12,
  lg: 16,
  xl: 24,
  "2xl": 32,
  "3xl": 48,
};

// Radius
export const radius = {
  none: 0,
  sm:   6,
  md:   8,
  lg:  12,
  xl:  16,
  full: 9999,
};

// Shadow (sade — yüksek elevation yok, B2B kurumsal hissi)
export const shadow = {
  none: "none",
  sm:  "0 1px 2px rgba(15,42,79,0.06)",
  md:  "0 1px 3px rgba(15,42,79,0.08), 0 1px 2px rgba(15,42,79,0.04)",
  lg:  "0 4px 12px rgba(15,42,79,0.10)",
  focus: "0 0 0 4px rgba(30,79,160,0.18)",
};

// Motion
export const motion = {
  fast: "120ms",
  base: "150ms",
  slow: "200ms",
  ease: "cubic-bezier(0.4, 0, 0.2, 1)",
};

// Z-index skala
export const zIndex = {
  dropdown:  1000,
  sticky:    1020,
  drawer:    1100,
  topbar:    1200,
  modal:     1300,
  popover:   1400,
  toast:     1500,
  tooltip:   1600,
};

export function tokensForMode(mode) {
  return mode === "dark" ? darkTokens : lightTokens;
}
